import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-order-item-status-badge',
  templateUrl: './order-item-status-badge.component.html',
  styleUrls: ['./order-item-status-badge.component.css']
})
export class OrderItemStatusBadgeComponent implements OnInit {

  @Input() id:number;
  constructor() { }

  ngOnInit() {
  }

}
